// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingPlaybackBelly = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 6.25c-3.17 0-5.75 2.58-5.75 5.75s2.58 5.75 5.75 5.75 5.75-2.58 5.75-5.75S15.17 6.25 12 6.25Zm0 12.5A6.758 6.758 0 0 1 5.25 12 6.758 6.758 0 0 1 12 5.25 6.758 6.758 0 0 1 18.75 12 6.758 6.758 0 0 1 12 18.75Zm0-9.375A2.628 2.628 0 0 0 9.375 12 2.628 2.628 0 0 0 12 14.625 2.628 2.628 0 0 0 14.625 12 2.628 2.628 0 0 0 12 9.375Zm0 6.25A3.63 3.63 0 0 1 8.375 12 3.63 3.63 0 0 1 12 8.375 3.63 3.63 0 0 1 15.625 12 3.63 3.63 0 0 1 12 15.625Zm0-12.5c-4.894 0-8.875 3.981-8.875 8.875S7.106 20.875 12 20.875s8.875-3.981 8.875-8.875S16.894 3.125 12 3.125Zm0 18.75c-5.445 0-9.875-4.43-9.875-9.875S6.555 2.125 12 2.125s9.875 4.43 9.875 9.875-4.43 9.875-9.875 9.875Z"
			fill="url(#OnboardingPlaybackBelly_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="OnboardingPlaybackBelly_tsx__a"
				x1={2.125}
				y1={2.125}
				x2={21.875}
				y2={21.875}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#75F0F0" />
				<stop offset={1} stopColor="#7575F0" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingPlaybackBelly;
